export function convertRelationships(relationship) {
  switch (relationship) {
    case 'DR':
      return 'Direct Report';
      break;
    case 'LM':
      return 'Line Manager';
      break;
    case 'P':
      return 'Peer';
      break;
    case 'O':
      return 'Other';
      break;
    default:
      return 'None';
  }
}
export function convertRelationshipTextToKey(relationship) {
  switch (relationship) {
    case 'Direct Report':
      return 'DR';
      break;
    case 'Line Manager':
      return 'LM';
      break;
    case 'Peer':
      return 'P';
      break;
    case 'Other':
      return 'O';
      break;
    default:
      return relationship;
  }
}
export function relationshipColor(relationship) {
  switch (relationship) {
    case 'DR':
      return '#54b99c';
      break;
    case 'LM':
      return '#dcdc00';
      break;
    case 'P':
      return '#5b4898';
      break;
    case 'O':
      return '#1c9ad7';
      break;
    default:
      return '#FFFFFF';
  }
}

export function average(array) {
  if (array.length) {
    return array.reduce((a, b) => a + b) / array.length;
  } else {
    return 0;
  }
}

export function convertTaskNames(taskNum) {
  switch (taskNum) {
    case '1':
      return 'Send instructions';
      break;
    case '2':
      return 'Send first reminders';
      break;
    case '3':
      return 'Send second reminders';
      break;
    case '4':
      return 'Send final reminders';
      break;
    default:
      return 'Default';
  }
}

export function convertScheduledTaskNames(taskNum) {
  switch (taskNum) {
    case '1':
      return 'Instructions';
    case '2':
      return 'First reminders';
    case '3':
      return 'Second reminders';
    case '4':
      return 'Final reminders';
    default:
      return 'Default';
  }
}

export function getUnique(arr, comp) {
  const unique = arr
    .map((e) => e[comp])

    // store the keys of the unique objects
    .map((e, i, final) => final.indexOf(e) === i && i)

    // eliminate the dead keys & store unique objects
    .filter((e) => arr[e])
    .map((e) => arr[e]);

  return unique;
}

export function difference(i, v) {
  return i - v;
}

export const sleep = async (time) => {
  return new Promise((resolve) => setTimeout(resolve, time));
};

export const arrayGenerator = (n) => {
  let arr = Array(n).fill('');
  return arr;
};

export const valueCheck = (n) => {
  if (!n || isNaN(+n)) {
    return 'N/A'
  }
  if (+n === 0.0) {
    return 'N/A'
  } else {
    return n
  }
};

export const percentageCheck = (n) => {
  if (!n || isNaN(+n)) {
    return 0
  }
  if (+n === 0.0) {
    return 0
  } else {
    return n
  }
};

export const urlConversion = (str) => {
  return str.replace(/\s/g, '-').toLowerCase();
};

export const breadcrumbSelect = (type) => {
  switch (type) {
    case 'Goal Tracker':
      return 'goal-tracker';
    case 'Team Assessment':
      return 'team-assessment';
    default:
      return '360';
  }
};

export const projectTypeText = (projectType, standard360, goalTracker, teamAssessment) => {
  if (projectType === '360') {
    return standard360;
  } else if (projectType === 'Goal Tracker') {
    return goalTracker;
  } else {
    return teamAssessment;
  }
};

export const emptyObjectCheck = (obj) => {
  if (obj) {
    if (Object.keys(obj).length > 0) {
      return true;
    }
    return false;
  } else {
    return false;
  }
};




export const getChartOptions = (captionsCount, captionsOrder, fontSize) => {
  const numberOfCaptions = Object.keys(captionsCount).length;
  return  {
    size: 700,
    axes: true, // show axes?
    scales: 5, // show scale circles?
    captions: true, // show captions?
    captionsCount: numberOfCaptions,
    captionsOrder,
    dots: true, // show dots?
    zoomDistance: 1.5, // where on the axes are the captions?
    axisProps: () => ({ className: 'axis', fill: 'none', stroke: '#000' }),
    scaleProps: () => ({ className: 'scale', fill: 'none', stroke: '#000' }),
    shapeProps: () => ({ className: 'shape' }),
    captionProps: () => ({
      className: 'caption',
      textAnchor: 'middle',
      fontSize,
      fontFamily: 'sans-serif',
    }),
  };
}

export const getTextWidth = (text, font = '500 12px sans-serif') => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  context.font = font;
  return context.measureText(text).width;
}

export const breakString = (word, maxWidth, hyphenCharacter = '-') => {
  const characters = word.split('');
  const lines = [];
  let currentLine = '';
  characters.forEach((character, index) => {
    const nextLine = `${currentLine}${character}`;
    const lineWidth = getTextWidth(nextLine);
    if (lineWidth >= maxWidth) {
      const currentCharacter = index + 1;
      const isLastLine = characters.length === currentCharacter;
      const hyphenatedNextLine = `${nextLine}${hyphenCharacter}`;
      lines.push(isLastLine ? nextLine : hyphenatedNextLine);
      currentLine = '';
    } else {
      currentLine = nextLine;
    }
  });
  return { hyphenatedStrings: lines, remainingWord: currentLine };
}

export const wrapLabel = (label, maxWidth) => {
  const words = label.split(' ');
  const completedLines = [];
  let nextLine = '';
  words.forEach((word, index) => {
    const wordLength = getTextWidth(`${word} `);
    const nextLineLength = getTextWidth(nextLine);
    if (wordLength > maxWidth) {
      const { hyphenatedStrings, remainingWord } = breakString(word, maxWidth);
      completedLines.push(nextLine, ...hyphenatedStrings);
      nextLine = remainingWord;
    } else if (nextLineLength + wordLength >= maxWidth) {
      completedLines.push(nextLine);
      nextLine = word;
    } else {
      nextLine = [nextLine, word].filter(Boolean).join(' ');
    }
    const currentWord = index + 1;
    const isLastWord = currentWord === words.length;
    if (isLastWord) {
      completedLines.push(nextLine);
    }
  });
  return completedLines.filter((line) => line !== '');
}
export const getClientItemListFilter = (orderedClientList) => {
  let clientItemListFilter = [
    {
      id: -1,
      title: 'All clients',
      selected: false,
      key: 'All',
    },
  ];

  orderedClientList.forEach((key, i) => {
    clientItemListFilter.push({
      id: i,
      title: key,
      selected: false,
      key: key,
    });
  })

  return clientItemListFilter;
}

export const sortProjects = (a,b,type) => {
  switch(type) {
    case 0:
      return a.title.localeCompare(b.title);
    case 1:
      return b.title.localeCompare(a.title);
    case 2:
      return b.createdDate - a.createdDate;
    case 3:
      return a.createdDate - b.createdDate;
    default:
      return a.title.localeCompare(b.title);
  }
}

export const sortRadarSections = (sectionIDs, sectionsLegacyMode, sectionDetails) => {
  return sectionIDs.sort((a,b) => {
    if (sectionsLegacyMode) {
      return sectionDetails[a].created - sectionDetails[b].created;
    } else {
      return sectionDetails[a].sortOrder - sectionDetails[b].sortOrder;
    }
  })
}

export const collectRadarCaptionsData = (captions, sectionsLegacyMode, sectionDetails) => {
  const radarSortedSectionIDs = sortRadarSections(Object.keys(captions), sectionsLegacyMode, sectionDetails);
  const numberOfRadarSections = radarSortedSectionIDs.length;
  const columns = radarSortedSectionIDs.map((key, i, all) => {
    return {
      key,
      caption: captions[key],
      angle: (Math.PI * 2 * i) / all.length,
      columnIndex: i,
    };
  });
  let captionKeysList = [];
  let captionKeysNeeded = false;
  if (numberOfRadarSections > 10) {
    captionKeysNeeded = true;
  } else {
    for (let i = 0; i < numberOfRadarSections; i++) {
      const sectionID = radarSortedSectionIDs[i];
      const {title} = sectionDetails[sectionID];
      let captionLabel = title;
      const wrappedCaptionLabel = wrapLabel(captionLabel, 90);
      const {angle} = columns[i];
      if (wrappedCaptionLabel.length > 5) {
        captionKeysNeeded = true;
        break;
      } else if (wrappedCaptionLabel.length > 3) {
        // top caption can be wider but if still too many lines then becomes key
        if (angle === 0) {
          captionLabel = wrapLabel(captionLabel, 150);
          if (captionLabel.length > 3) {
            captionKeysNeeded = true;
            break;
          }
        } else if (angle < 1.1 || angle > 5.1) {
          // captions either side of top become keys if too long
          captionKeysNeeded = true;
          break;
        }
      }
    }
  }

  radarSortedSectionIDs.forEach((sectionID, i) => {
    let labelToAdd;
    if (captionKeysNeeded) {
      labelToAdd = 'C' + (i + 1);
    } else {
      labelToAdd = sectionDetails[sectionID].title;
    }
    sectionDetails[sectionID].label = labelToAdd;
    captions[sectionID] = labelToAdd;
  })


  if (captionKeysNeeded) {
    captionKeysList = radarSortedSectionIDs;
  }

  return {
    captions,
    sectionDetails,
    radarSortedSectionIDs,
    numberOfRadarSections,
    captionKeysList
  }
}